import StateType from '@/store/types/StateType';
import {availableLocales, initialLocale} from '@/translations';

let locale = null;

if (typeof window !== 'undefined') {
	const localeParam = window.location.pathname
		.substr(1)
		.split('/')[0];

	if (availableLocales.indexOf(localeParam) > -1) {
		locale = localeParam;
	}
}

const state: StateType = {
	animationComplete: true,
	animationCards: {
		homepageTopFirst: [''],
		homepateTopSecond: [''],
		homepageBottomFirst: [''],
		homepateBottomSecond: ['']
	},
	location: 'EU',
	locale: locale ? locale : (serverVariables.httpRequest.locale || initialLocale),
	global: {
		width: 0,
		isMobile: false,
		overflow: false,
		menuOpen: false,
		preloaded: false
	},
	fetching: {
		recaptchaP: false,
		contactFormG: false,
		getAppT: false,
	},
	recaptcha: null,
	scrollToInfo: {
		scrollDir: -1,
		lastScrollTop: 0
	},
	headerInfo: {
		visible: true,
		open: false,
		height: 0
	},
	cookiesHeight: 0,
	menu: {
		isOpen: false
	},
	iconCache: new Map(),
	iconCacheTracker: 0,
	help: {
		activeItem: 0,
		activeCategory: 0
	},
	activeModal: null,
	cardsIncluded: {},
	cookies: false
};

export default state;
